import _Vue, { PluginObject } from 'vue';

import { ux1Currency, ux1Data, ux1Date } from '@/Common/Utils/General/Modules';

const UX1DataPlugin: PluginObject<null> = {
	install: (Vue: typeof _Vue): void => {
		Vue.prototype.$ux1Data = ux1Data;
	}
};
const UX1CurrencyPlugin: PluginObject<null> = {
	install: (Vue: typeof _Vue): void => {
		Vue.prototype.$ux1Currency = ux1Currency;
	}
};
const UX1DatePlugin: PluginObject<null> = {
	install: (Vue: typeof _Vue): void => {
		Vue.prototype.$ux1Date = ux1Date;
	}
};

export const allPlugins = [UX1DatePlugin, UX1CurrencyPlugin, UX1DataPlugin];
export const DevFlagsPlugin: PluginObject<Host.IDevFlags> = {
	install: (Vue: typeof _Vue, options = { isLocalDev: false, isHostDevMode: false }): void => {
		const { isLocalDev, isHostDevMode } = options;

		Vue.prototype.$ux1IsLocalDev = isLocalDev;
		Vue.prototype.$ux1IsHostDevMode = isHostDevMode;
	}
};

export const getTranslatePlugin = (t: App.TranslateFn): PluginObject<null> => ({
	install: (Vue: typeof _Vue): void => {
		if (!Vue.prototype.$t) {
			Vue.prototype.$t = t;
		}
	}
});
